import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AppInjector, LanguageModule, ModalLayoutModule, PageLayoutModule, PurchaseModule, PurchasingService } from 'army-builder-shared';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgLetModule } from 'ng-let';

import { SubscriptionListComponent } from './subscription-list/component';
import { CardListComponent } from './card-list/component';
import { AdminEntitlementPanelComponent } from './admin-entitlement-panel.component';
import { FalloutPurchasingServiceCapacitor } from './fallout-purchasing.service.capacitor';
import { Capacitor } from '@capacitor/core';
import { FalloutPurchasingServiceWeb } from './fallout-purchasing.service.web';
import { SubscriptionModule } from '../subscription/subscription.module';

@NgModule({
    declarations: [SubscriptionListComponent, CardListComponent],
    imports: [
        CommonModule,
        IonicModule,
        PurchaseModule,
        TranslateModule,
        LanguageModule,
        PageLayoutModule,
        ModalLayoutModule,
        NgLetModule,
        RouterModule,
        SubscriptionModule,
        AdminEntitlementPanelComponent
    ],
    providers: [
        FalloutPurchasingServiceCapacitor,
        FalloutPurchasingServiceWeb,
        {
            provide: PurchasingService,
            useFactory: () => {
                const platform = Capacitor.getPlatform();
                console.log('platform', platform);
                if (platform === 'ios' || platform === 'android') {
                    return AppInjector.get(FalloutPurchasingServiceCapacitor);
                } else {
                    return AppInjector.get(FalloutPurchasingServiceWeb);
                }
            }
        }
    ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class FalloutSubscriptionPageModule {}
